import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { NotInvitedEmployeesDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import { useAllEmployeesWithAccess } from 'modules/employees/components/EmployeeCollection/Header/lib/useAllEmployeesWithAccess'
import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import invitationsCollection from 'modules/employees/store/collections/invitations'

interface Props {
  isHidden: boolean
  onClose: () => void
}

type SelectionState = { type: 'manual' | 'all'; ids?: number[] }

const NotInvitedModal = ({ isHidden, onClose }: Props) => {
  const [selection, setSelection] = React.useState<SelectionState>({ type: 'manual', ids: [] })

  // Load all employees for the selector and access IDs for "Select All"
  const { employees, accessIds, loading } = useAllEmployeesWithAccess(NotInvitedEmployeesDocument, {
    skip: isHidden,
  })

  if (isHidden) return null

  const handleClose = () => {
    setSelection({ type: 'manual', ids: [] })
    onClose()
  }

  const handleSubmit = async () => {
    track(trackingEvents.employee.employeesSendInviteFinish)

    // Select All uses all accessIds, manual selection uses selected ids
    const idsToInvite = selection.type === 'all' ? accessIds : selection.ids ?? []

    const { success } = await asyncAction(
      async () => {
        await invitationsCollection.rpc('bulk_invite', { accesses_ids: idsToInvite })
      },
      { loadingMessage: i18n.t('employees.not_invited_modal.loading_message') }
    )
    if (success) handleClose()
  }

  return (
    <Modal
      title={i18n.t('employees.not_invited_modal.title')}
      description={i18n.t('employees.not_invited_modal.description')}
      illustration="group"
      onSubmit={handleSubmit}
      onClose={handleClose}
      footer={<Button submit>{i18n.t('employees.not_invited_modal.submit')}</Button>}
    >
      {loading ? null : (
        <EmployeeSelectorV2
          useAccessId
          forcedFilters={{ employeeIds: employees.map((e) => e.id) }}
          onChange={setSelection}
          multiple
        />
      )}
    </Modal>
  )
}

export default NotInvitedModal
